// extracted by mini-css-extract-plugin
export const wrapper = "header-module--wrapper--182n5";
export const content = "header-module--content--1qWPI";
export const home = "header-module--home--3nrdn";
export const navigation = "header-module--navigation--2IUaJ";
export const active = "header-module--active--2DNib";